import {observable, makeObservable} from "mobx";
import {BaseViewModel} from "./base-view-model";
import {BaseLinkModel} from "./link/base-link-model";

export class ListItemViewModel extends BaseViewModel {
  linkModel: BaseLinkModel;
  visible: Boolean = true;
  @observable active: Boolean = false;
  index: Number;

  constructor(model: ListItemViewModel) {
    super(model);

    this.index = model.index;
    this.linkModel = model.linkModel;
    this.visible = model.visible;
    this.active = model.active;

    makeObservable(this);
  }
}
